import React, { useState, useEffect } from "react";
import { CartIcon, HeartIcon } from "../GetIcons";
import { useAuth } from "../../contexts/AuthProvider";
import { useTelegram } from "../../hooks/useTelegram"
import Item from "../Item/Item";
import Back from "../../assets/back.svg";
import "./AllItems.scss";
import { updateFavorite } from "../../router/apiServiceFetch";

const AllItems = ({ onClose, popupTitle, allItems, type, cartItems, handleRemoveFromCart, handleAddToCart }) => {

    const { userBase } = useAuth();
    const { tg, triggerHapticFeedback } = useTelegram();
    const [filteredItems, setFilteredItems] = useState([]);
    const [isVisible, setIsVisible] = useState(false);
    const [selected, setSelected] = useState(null);
    const [groups, setGroups] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);

    const filePath = process.env.REACT_APP_FILE_PATH;
    // Generate groups with "Все" and game names
    useEffect(() => {
        let newGroups = [];
        if (type > 4) {
            if (Array.isArray(allItems)) {
                // Generate groups from gameGroups
                newGroups = allItems.flatMap((game) =>
                    game.gameGroups.map((group) => ({
                        name: group.groupName, // Group name
                        id: group.groupId, // Group ID
                    }))
                );


                // Set default selected group
                if (newGroups.length > 0) {
                    setSelected(newGroups[0].id);
                    setFilteredItems(
                        allItems
                            .flatMap((game) =>
                                game.gameGroups.filter(
                                    (group) => group.groupId === newGroups[0].id
                                )
                            )
                            .flatMap((group) => group.items)
                    );
                } else {
                    setSelected(null); // No groups to select
                    setFilteredItems([]); // Clear filtered items
                }
            }
        } else {
            // Generate groups from games
            newGroups = allItems.map((game) => ({
                name: game.name, // Game name
                id: game.gameId, // Game ID
                parentFileName: game.parentFileName,
            }));


            if (newGroups.length > 0) {
                setSelected(newGroups[0].id);
            } else {
                setSelected(null);
            }

            // Filter items based on selected or all
            setFilteredItems(
                selected === null
                    ? allItems.flatMap((game) => game.items)
                    : allItems
                        .flatMap((game) => game.items)
                        .filter((item) => item.gameId === selected)
            );
        }

        // Set groups for navigation
        setGroups(newGroups);
    }, [allItems, type]);



    useEffect(() => {
        if (type > 4) {
            const items = selected
                ? allItems
                    .flatMap((game) =>
                        game.gameGroups.filter((group) => group.groupId === selected)
                    )
                    .flatMap((group) => group.items)
                : allItems.flatMap((game) =>
                    game.gameGroups.flatMap((group) => group.items)
                );

            // Sort items by isNew, isPopular, and sort
            const sortedItems = items.sort((a, b) => {
                if (a.isPopular !== b.isPopular) return b.isPopular - a.isPopular; // isPopular items next
                if (a.isNew !== b.isNew) return b.isNew - a.isNew; // isNew items first
                return a.sort - b.sort; // Finally, sort by the 'sort' field
            });

            setFilteredItems(sortedItems);
        } else {
            setFilteredItems(
                selected
                    ? allItems
                        .filter((game) => game.gameId === selected)
                        .flatMap((game) => game.items)
                    : allItems.flatMap((game) => game.items)
            );
        }
    }, [selected, allItems, type]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setIsVisible(true);
        }, 10);
        return () => clearTimeout(timeout);
    }, []);

    const handleClose = () => {
        setIsVisible(false);
        setTimeout(() => {
            onClose();
        }, 300);
    };


    const formatCurrency = (number) => {
        return new Intl.NumberFormat("ru-RU", {
            currency: "RUB",
            minimumFractionDigits: 2,
        }).format(number) + " руб";
    };
    const formatCurrencyDisc = (number) => {
        return new Intl.NumberFormat("ru-RU", {
            currency: "RUB",
        }).format(number);
    };

    const handleAdd = (item) => {
        handleAddToCart(item);
    };

    // Уменьшить количество товара
    const handleRemove = (item) => {
        handleRemoveFromCart(item);
    };

    // Get filtered items based on the selected game

    const handleFav = async (item) => {
        let updatedItems;

        // Toggle favorite status for the item if type is not 5
        updatedItems = filteredItems.map((gameItem) => {
            if (gameItem.itemId === item.itemId) {
                return { ...gameItem, isFav: !gameItem.isFav };
            }
            return gameItem;
        });


        // Update the state with the modified items
        setFilteredItems(updatedItems);

        try {
            // Update the favorite status on the server
            await updateFavorite(userBase.userId, item.itemId);
        } catch (error) {
            console.error("Error updating favorite:", error);
        }
    };
    const handleGameItemClick = (item) => {
        triggerHapticFeedback("impact", "medium");
        setSelectedItem(item); // Set the clicked item as the selected item
    };


    // Close the Item detail view
    const handleItemClose = () => {
        setSelectedItem(null);
    };
    return (
        <div className={`allItems-cont ${isVisible ? "visible" : ""}`}>
            {selectedItem ? (
                <Item gameItem={selectedItem} onClose={handleItemClose} />
            ) : (
                <div className="allItems">
                    <div className="nav">
                        <div className="back-nav">
                            <div className="back-btn" onClick={handleClose}>
                                <button>
                                    <img src={Back} alt="back" />
                                </button>
                            </div>
                            <h2>{popupTitle}</h2>
                        </div>
                    </div>
                    {/* Items Display */}
                    <div className="allItems-content">
                        {groups &&
                            <div className="game-nav">
                                <div className="game-nav-cont">
                                    {groups.map((game) => (
                                        <button
                                            key={game.id}
                                            className={selected === game.id ? "active" : ""}
                                            onClick={() => {
                                                setSelected(game.id)
                                                triggerHapticFeedback('impact', 'medium')
                                            }}
                                        >
                                            {game.parentFileName && <img src={`${filePath}/Games/${game.parentFileName}`} alt={game.name} className="grp" />}
                                            {game.name}
                                        </button>
                                    ))}

                                </div>
                            </div>
                        }

                        <div className="gridItems">
                            {filteredItems.map((item, index) => {
                                const cartItem = cartItems.find((cartItem) => cartItem.itemId === item.itemId);
                                return (
                                    <div className="gameSlide" key={index}>
                                        <div className="gameSlide-inner">
                                            <img
                                                src={`${filePath}/Games/${item.fileName}`}
                                                alt={item.name}
                                                className="slideImage"
                                                onClick={() => handleGameItemClick(item)}
                                            />
                                            <div className={`heartIcon ${item.isFav ? "isActiveFave" : ""}`}
                                                onClick={() => handleFav(item)} // Fixed: Wrap in an arrow function
                                            >
                                                <HeartIcon fillColor={item.isFav ? "#4A0073" : "#fff"} stroke={item.isFav ? "#8E00DD " : "none"} />
                                            </div>
                                            {item.isNew && !item.isPopular && type > 4 && <p className="isNew">Новинка</p>}
                                            {item.isPopular && type > 4 && <p className="isPopular">Популярное</p>}
                                            <div className="gameSliderText"
                                                onClick={() => handleGameItemClick(item)}>
                                                <h3>{item.name}</h3>
                                                <div>

                                                    <p>
                                                        {formatCurrency(item.priceAfterDiscount)}
                                                    </p>
                                                    {item.discount > 0 && <span className="disc">-{item.discount}%</span>}
                                                </div>
                                            </div>
                                            {cartItem ? (
                                                <div className="gameSliderBtnDiv">
                                                    <div className="gameSliderButtons">
                                                        <button onClick={() => handleRemove(item)}>
                                                            -
                                                        </button>
                                                    </div>
                                                    <p className="quantity">{cartItem.quantity}</p>
                                                    <div className="gameSliderButtons">
                                                        <button onClick={() => handleAdd(item)}>
                                                            +
                                                        </button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="gameSliderBtn">
                                                    <button onClick={() => handleAdd(item)}>
                                                        В Корзину
                                                        <CartIcon fillColor="#FFAA00" />
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                    </div>
                </div>)}
        </div>
    );
};

export default AllItems;
